module.exports = __webpack_public_path__ + "static/logo4-94e7616d9a0d9134767a76882ab123cb.svg";